
const DirectiveEntryExecutionEntryOnGoingFinancialReview = () => {
  return (
    <p className="text-white-300">
      Aguardando análise financeira
    </p>
  );
}

export default DirectiveEntryExecutionEntryOnGoingFinancialReview;
